import { useEffect, useState } from "react";
import "./AtivarModal.css";

export default function AtivarModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function handleOk() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.message || "Falha ao ativar");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (!open) return;

    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose?.();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        handleOk();
      }
    };

    document.addEventListener("keydown", onKey, true);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="atvmd-bg">
      <div className="atvmd-box" role="dialog" aria-modal="true" aria-label="Ativar ativo">
        <header className="atvmd-head">
          <h3 className="atvmd-title">Ativar</h3>
          <button className="atvmd-x" onClick={onClose} type="button" aria-label="Fechar" title="Fechar" disabled={busy}>
            x
          </button>
        </header>

        <div className="atvmd-body">
          Deseja <strong>ativar</strong> "{titulo || "este item"}"?
          {err ? <div className="atvmd-err">{err}</div> : null}
        </div>

        <footer className="atvmd-foot">
          <button className="atvmd-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="atvmd-btn atvmd-btn-ok" type="button" onClick={handleOk} disabled={busy}>
            {busy ? "Ativando..." : "Ativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}
